import {Box} from "@mui/system";
import {Button, CircularProgress, Typography} from "@mui/material";
import LoginTextField from "../LoginTextField/LoginTextField";
import {ChangeEvent, FormEvent, useState} from "react";

type TokenBoxProps = {
    value: string
    error: boolean
    setToken: Function
    onCancel: Function
    handleSubmit: (ev: FormEvent) => Promise<void>
    loading: boolean
    invalid?: boolean
    signupProcess?: boolean
}

const formSx = {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
};

const boxSx = {
    display: 'flex',
    flex: 1,
    gap: 1,
    justifyContent: 'space-between',
    alignItems: 'flex-end'
};

const TokenBox = ({
    value,
    setToken,
    onCancel,
    error,
    handleSubmit,
    loading,
    signupProcess=true
}: TokenBoxProps) => {
    const [invalid, setInvalid] = useState(false);

    const tokenHelperText = () => {
        if (error) {
            return 'This TOTP token is invalid or has expired. Please enter a new token and try again.';
        }
        return 'Please enter your 6-digit TOTP token. If you have lost access to the device that generates your tokens, please contact your NL-ix administrator.';
    };


    return(
        <Box component="form" onSubmit={handleSubmit} sx={formSx}>
            <Typography variant="h2" gutterBottom>
                Just one more thing...
            </Typography>
            <Typography variant="body1" gutterBottom>
                Please enter an authentication token from e.g. your mobile device to finish {signupProcess ? 'signing in' : 'resetting your password' }.
            </Typography>
            <LoginTextField
                id="token"
                label="Authentication token:"
                onChangeHandler={(ev: ChangeEvent<HTMLInputElement>, value: string) => {
                    setToken(value);
                    setInvalid(!(ev.target.checkValidity()));
                }}
                type="text"
                placeholder="000000"
                value={value}
                error={Boolean(error)}
                helperText={tokenHelperText()}
                required={true}
                inputProps={{ pattern: '\\d{6,6}' }}
            />
            <Box sx={boxSx}>
                <Button
                    id="cancel-button"
                    variant="outlined"
                    color="primary"
                    onClick={() => onCancel()}
                    sx={{ flex: 1}}
                >
                    Cancel
                </Button>
                <Button
                    id="submit-button"
                    variant="contained"
                    color="success"
                    sx={{ flex: 1}}
                    disabled={ value === ''|| invalid || loading || error}
                    endIcon={loading ? <CircularProgress size={14} color={'inherit'}/>: null}
                    type={"submit"}
                >
                    {signupProcess ? 'Sign in' : 'Reset Password'}
                </Button>
            </Box>
        </Box>


    );
};

export default TokenBox;
